import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * RootAuthRedirect - Handles Firebase auth action links that come to the root domain
 * and redirects them to the appropriate auth action handler.
 */
const RootAuthRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if there are Firebase auth action parameters in the URL
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get('mode');
    const oobCode = queryParams.get('oobCode');

    if (mode && oobCode) {
      console.log('Root domain received Firebase auth action, redirecting to handler:', mode);
      // Redirect to the auth action handler with all parameters
      navigate(`/auth/action${location.search}`, { replace: true });
    } else {
      // No auth action parameters, redirect to normal home logic
      navigate('/gyms', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div className="loading-indicator">
      Processing...
    </div>
  );
};

export default RootAuthRedirect;
